import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MediaQuery, { MEDIA_QUERIES } from '../common/media_query';
import ResponsiveImg from '../common/responsive_img';
import Lazy from '../common/lazy';
import {find, get} from 'lodash';
import classNames from 'classnames';

export default class HeroImage extends Component {
  state = { isLoaded: false };

  handleImgLoad = () =>
    this.setState({ isLoaded: true });

  render() {
    const { opener_images, asset_opener_article_full, asset_main, alt } = this.props;
    const eightByThreeOpener = get(find(opener_images, { type: '8x3' }), 'asset.src.full');
    // TODO: Figure out if any article is actually still using the "legacy opener".
    const legacyOpener = (asset_opener_article_full.src_full === asset_main.src_full)
      ? null
      : asset_opener_article_full.src_full;
    const isLoadingClassName = classNames({ loading: !this.state.isLoaded });

    const mobileOpener = get(find(opener_images, { type: '5x6' }), 'asset.src.full');
    const mobileWidth = MEDIA_QUERIES.mobile.maxWidth;
    const mobileHeight = mobileWidth * 6 / 5;
    const tabletWidth = MEDIA_QUERIES.tablet.maxWidth;
    const tabletHeight = tabletWidth * 3 / 8;
    const desktopWidth = 1800;
    const desktopHeight = desktopWidth * 3 / 8;

    const commonImgProps = {
      className: classNames('content', isLoadingClassName),
      onLoad: this.handleImgLoad,
      format: 'alwaysForceJpgHq'
    };

    return (
      <div className="opener">
        <MediaQuery breakpoint="desktop">
          <Lazy className={`full-width-opener ${isLoadingClassName}`}>
            <ResponsiveImg
              {...commonImgProps}
              src={legacyOpener || eightByThreeOpener}
              alt={alt}
              width={desktopWidth}
              height={desktopHeight}
            />
          </Lazy>
        </MediaQuery>
        <MediaQuery breakpoint="tablet">
          <Lazy className={`full-width-opener ${isLoadingClassName}`}>
            <ResponsiveImg
              {...commonImgProps}
              src={legacyOpener || eightByThreeOpener}
              alt={alt}
              width={tabletWidth}
              height={tabletHeight}
            />
          </Lazy>
        </MediaQuery>
        <MediaQuery breakpoint="mobile">
          <Lazy className={`full-width-opener ${isLoadingClassName}`}>
            <ResponsiveImg
              {...commonImgProps}
              src={mobileOpener}
              alt={alt}
              width={mobileWidth}
              height={mobileHeight}
            />
          </Lazy>
        </MediaQuery>
      </div>
    );
  }
}

HeroImage.propTypes = {
  asset_main: PropTypes.shape({
    src_full: PropTypes.string
  }).isRequired,
  alt: PropTypes.string,
  asset_opener_article_full: PropTypes.shape({
    src_full: PropTypes.string
  }).isRequired,
  opener_images: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    asset: PropTypes.shape({
      src: PropTypes.shape({
        full: PropTypes.string
      })
    })
  })).isRequired
};
